import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d597be4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-10" }
const _hoisted_5 = { class: "jobtype" }
const _hoisted_6 = {
  key: 0,
  class: "font-weight-bold"
}
const _hoisted_7 = {
  key: 1,
  class: "font-weight-bold customer"
}
const _hoisted_8 = { class: "col-md-1 p-0" }
const _hoisted_9 = { style: {"float":"right"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-window-maximize" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-window-minimize" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "col-md-1 p-0 pl-2" }
const _hoisted_15 = { style: {"float":"left"} }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 0,
  class: "card-body"
}
const _hoisted_19 = { class: "second-div" }
const _hoisted_20 = {
  key: 0,
  class: "mb-1",
  style: {"white-space":"normal"}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Title note ")
], -1))
const _hoisted_22 = { class: "ml-1" }
const _hoisted_23 = {
  class: "mb-1",
  style: {"white-space":"normal"}
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Date ")
], -1))
const _hoisted_25 = { class: "ml-1" }
const _hoisted_26 = { class: "ml-1" }
const _hoisted_27 = { class: "ml-1" }
const _hoisted_28 = {
  key: 0,
  class: "mb-1",
  style: {"white-space":"normal"}
}
const _hoisted_29 = { key: 0 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-4" }, null, -1))
const _hoisted_31 = { class: "ml-1" }
const _hoisted_32 = { class: "ml-1" }
const _hoisted_33 = { class: "ml-1" }
const _hoisted_34 = { class: "ml-1" }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = {
  key: 0,
  class: "mb-1",
  style: {"white-space":"normal"}
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-4" }, null, -1))
const _hoisted_38 = { class: "ml-1" }
const _hoisted_39 = { class: "ml-1" }
const _hoisted_40 = { class: "ml-1" }
const _hoisted_41 = { class: "ml-1" }
const _hoisted_42 = {
  key: 2,
  class: "mb-1",
  style: {"white-space":"normal"}
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Appointment time ")
], -1))
const _hoisted_44 = { class: "ml-1" }
const _hoisted_45 = {
  key: 3,
  class: "piname"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "PI ")
], -1))
const _hoisted_47 = {
  key: 4,
  class: "mb-1",
  style: {"white-space":"normal"}
}
const _hoisted_48 = {
  key: 0,
  class: "piname"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-3" }, null, -1))
const _hoisted_50 = { class: "ml-1" }
const _hoisted_51 = { key: 5 }
const _hoisted_52 = {
  key: 0,
  class: "piname"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-3" }, null, -1))
const _hoisted_54 = { class: "ml-1" }
const _hoisted_55 = { key: 6 }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Booked By")
], -1))
const _hoisted_57 = { class: "ml-1" }
const _hoisted_58 = { class: "ml-1" }
const _hoisted_59 = { class: "ml-1" }
const _hoisted_60 = { key: 7 }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "TT ", -1))
const _hoisted_63 = {
  key: 1,
  class: "ml-1"
}
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "TT ", -1))
const _hoisted_65 = {
  key: 2,
  class: "ml-1"
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "TT ", -1))
const _hoisted_67 = {
  key: 8,
  class: "mb-1",
  style: {"white-space":"normal"}
}
const _hoisted_68 = { key: 0 }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Key pickup/Access ", -1))
const _hoisted_70 = {
  key: 1,
  class: "ml-1"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Branch ", -1))
const _hoisted_72 = {
  key: 2,
  class: "ml-1"
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Phone ", -1))
const _hoisted_74 = {
  key: 9,
  class: "mb-1",
  style: {"white-space":"normal"}
}
const _hoisted_75 = { key: 0 }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Return/Key Release ", -1))
const _hoisted_77 = {
  key: 1,
  class: "ml-1"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Branch ", -1))
const _hoisted_79 = {
  key: 10,
  class: "mb-1"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"white-space":"normal","color":"red"} }, [
  /*#__PURE__*/_createElementVNode("b", null, "Primary Issues ")
], -1))
const _hoisted_81 = {
  key: 11,
  class: "mb-1"
}
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"white-space":"normal","color":"#bd8319"} }, [
  /*#__PURE__*/_createElementVNode("b", null, "Secondary Issues ")
], -1))
const _hoisted_83 = { class: "first-div" }
const _hoisted_84 = ["title"]
const _hoisted_85 = ["title"]
const _hoisted_86 = {
  key: 2,
  class: "fa fa-check-circle icon-botton-right",
  style: {"color":"yellowgreen"},
  title: "Job fully confirmed"
}
const _hoisted_87 = ["title"]

import { computed, inject, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useToast } from "vue-toastification";
import { Dictionary, Inspector, SelectOption, Booking, PresetError } from "@/models";
import { getAppointmentcolour } from "@/utilities";
import Ably from "ably";
import moment from 'moment-timezone';

export default /*#__PURE__*/_defineComponent({
  __name: 'ManagementResultTemplate',
  props: {
    highlight: {},
    picolour: { type: Boolean },
    rightclick: { type: Boolean },
    showdate: { type: Boolean },
    templateModel: {}
  },
  emits: ['removebookingfromlocal'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const realtime: Ably.Realtime = inject('realtime');
const channel = realtime.channels.get('diary');
const actProperty: any = inject('actProperty');
const store = useStore();

const dictionary = computed((): Dictionary => store.getters['dictionary/current']);
const inspectorlist = computed((): Inspector[] => store.getters['diary/inspectorlist']);
const selectedbooking = computed(() => store.getters['diary/booking'] as Booking);
const emit = __emit;

const prepdate = ref("");
const cidate = ref("");


const bookingInprogress = async (booking: Booking) => {
  if (booking && booking.id) {
    await store.dispatch('diary/bookingInprogress', booking)
      .then((b: Booking) => {
        booking.inprogress = b.inprogress;
        channel.publish('bookinginprogress', { bookingid: b.id });
      });
  }
};
const bookingNotinprogress = async (booking: Booking) => {
  if (booking && booking.id) {
    await store.dispatch('diary/bookingNotinprogress', booking)
      .then((b: Booking) => {
        booking.inprogress = b.inprogress;
        channel.publish('bookingnotinprogress', { bookingid: b.id });
      })
  }
};

onMounted(() => {
  if (props.templateModel.appointmentData.subtype === Booking.PREP) {
    if (props.templateModel.appointmentData.leadbooking?.id) {
      cidate.value = props.templateModel.appointmentData.leadbooking.bookingdate;
    }
  } else if (props.templateModel.appointmentData.subbookings) {
    props.templateModel.appointmentData.subbookings.forEach((b: Booking) => {
      if (b.subtype === Booking.PREP) {
        prepdate.value = b.bookingdate;
      }
    });
  }
});


const _appointmenttime = computed(() => {
  let apptime = moment(booking.value.appointmenttime).utc().format("h:mm a");
  if (apptime === "12:00 am") apptime = "No Tenant but Fixed Time";
  if (apptime === "12:15 am") apptime = "Flexi all day";
  if (apptime === "12:20 am") apptime = "Flexi AM";
  if (apptime === "12:25 am") apptime = "Flexi PM";
  return apptime;
});

const primaryErrors = computed(() => {
  return booking.value.preseterrors.filter(((f: PresetError) => f.category === 'primary'));
});
const secondaryErrors = computed(() => {
  return booking.value.preseterrors.filter(((f: PresetError) => f.category === 'secondary'));
});

const booking = computed(() => {
  return props.templateModel?.appointmentData;
});

const subbookingdatetimeflag = computed(() => {
  let prepJob = booking.value.subbookings.filter(((f: any) => f.subtype === 'Prep' || f.subtype === 'Key'));
  if (prepJob.length > 0) {
    return true;
  } else {
    return false;
  }
});

const prepandKeyJobData = computed(() => {
  let prepandKeyJob = booking.value.subbookings.filter(((f: any) => f.subtype === 'Prep' || f.subtype === 'Key'));
  return prepandKeyJob;
});

const title = computed(() => {
  return actProperty.getBookingTitle(booking.value, dictionary.value);
});

const appointmentstyle = computed(() => {
  if (!props.picolour) return "";
  let style = "";
  if (booking.value.id === props.highlight) {
    style = `background-image: conic-gradient(from var(--border-angle), ${appointmentcolour.value}, ${appointmentcolour.value} 50%, ${appointmentcolour.value}), conic-gradient(from var(--border-angle), transparent 20%, #253746, #eadb40);`;
  } else {
    style = `background: ${appointmentcolour.value};`;
  }
  return style;
});

const skulltitle = computed(() => {
  let title = '';
  if (booking.value.checkoutWithoutPreviousReport) {
    title = 'Previous report not present';
  } else if (booking.value.checkoutWithoutDataentry) {
    if (!booking.value.dataentryreport)
      title = 'Dataentry report is missing';
    else if (booking.value.dataentryreport.dataentrystatus != 'Upload Complete')
      title = 'Dataentry report is not completed by dataentry team';
  }
  return title;
});

const appointmentcolour = computed(() => {
  return getAppointmentcolour(booking.value, inspectorlist.value);
});

const getPresetErrorMessage = (error: PresetError) => {
  const errors = [{
    message: "No PDF Upload Doc for CO off upload",
    presetnumber: 1,
    flag: false
  }, {
    message: "Missing upload ref for CO off upload",
    presetnumber: 2,
    flag: false
  }, {
    message: "Appointment time falls outside of booking time",
    presetnumber: 3,
    flag: false
  }, {
    message:
      "Appointment time is not the same as booking start time when access is via tenant",
    presetnumber: 4,
    flag: false
  }, {
    message: "Booking start time falls outside of agency opening hours",
    presetnumber: 7,
    flag: false
  }, {
    message: "Access via tenant for CO/SOC unconfirmed",
    presetnumber: 5,
    flag: false
  }, {
    message: "Access unconfirmed (excluding clients that have opted out)",
    presetnumber: 6,
    flag: false
  }, {
    message: "Provisional booking (all job types)",
    presetnumber: 8,
    flag: false
  }];
  const index = errors.findIndex((e) => e.presetnumber === error.presetnumber);
  if (index >= 0)
    return errors[index].message;
  else
    return error.message;
};

const removeBookingFromList = (booking: Booking) => {
  emit("removebookingfromlocal", booking);
}
const masterReportType = computed(() => {
  return actProperty.formatReportType(booking.value.leadbooking?.jobtype, dictionary)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["booking", {
    'selectedbookingcard': booking.value.id === selectedbooking.value.id
  }]),
    id: 'appointment-box-' + booking.value.id,
    style: _normalizeStyle(appointmentstyle.value)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["card custom-box-shadow text-bg-light mb-6", { 'text-bg-secondary': booking.value.id === selectedbooking.value.id, 'inprogress': booking.value.inprogress }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(), _createElementBlock("span", {
                class: "font-weight-bold",
                key: booking.value.updatedAt
              }, _toDisplayString(title.value), 1)),
              (booking.value.addressPreviewLine1 || booking.value.addressPreviewLine2)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, " - " + _toDisplayString(booking.value.address.displayaddress), 1))
                : _createCommentVNode("", true),
              (booking.value.customer && (booking.value.customer.companyName || booking.value.keypickupbranchname || booking.value.customer.branchName))
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, " - " + _toDisplayString(booking.value.customer.companyName) + " - " + _toDisplayString(booking.value.keypickupbranchname ? booking.value.keypickupbranchname : booking.value.customer.branchName), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, [
              (booking.value.inprogress)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "close",
                    "data-dismiss": "modal",
                    "aria-label": "Close",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (bookingNotinprogress(booking.value)), ["stop"])),
                    style: _normalizeStyle({ color: booking.value.id === selectedbooking.value.id ? 'white !important' : 'black !important' })
                  }, _hoisted_11, 4))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "close",
                    "data-dismiss": "modal",
                    "aria-label": "Close",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (bookingInprogress(booking.value)), ["stop"])),
                    style: _normalizeStyle({ color: booking.value.id === selectedbooking.value.id ? 'white !important' : 'black !important' })
                  }, _hoisted_13, 4))
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, [
              _createElementVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                "aria-label": "Close",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (removeBookingFromList(booking.value)), ["stop"])),
                style: _normalizeStyle({ color: booking.value.id === selectedbooking.value.id ? 'white !important' : 'black !important' })
              }, _hoisted_17, 4)
            ])
          ])
        ])
      ]),
      (!booking.value.inprogress)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", null, [
                (booking.value.titlenotes)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("span", null, [
                        _createElementVNode("span", _hoisted_22, _toDisplayString(booking.value.titlenotes), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("span", null, [
                    _createElementVNode("span", _hoisted_25, _toDisplayString(booking.value.bookingdate), 1),
                    _createElementVNode("span", _hoisted_26, _toDisplayString(booking.value.starttime), 1),
                    _createElementVNode("span", _hoisted_27, _toDisplayString(booking.value.endtime), 1)
                  ]),
                  (subbookingdatetimeflag.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prepandKeyJobData.value, (prepdata, $prepdata) => {
                          return (_openBlock(), _createElementBlock("div", { key: $prepdata }, [
                            (prepdata?.startdate || prepdata?.enddate)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                  _hoisted_30,
                                  _createElementVNode("span", _hoisted_31, _toDisplayString(prepdata.bookingdate), 1),
                                  _createElementVNode("span", _hoisted_32, _toDisplayString(prepdata.starttime), 1),
                                  _createElementVNode("span", _hoisted_33, _toDisplayString(prepdata.endtime), 1),
                                  _createElementVNode("span", _hoisted_34, " (" + _toDisplayString(prepdata.subtype) + ") ", 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (booking.value?.leadbooking)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      (booking.value?.leadbooking?.startdate || booking.value.leadbooking?.enddate)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            _hoisted_37,
                            _createElementVNode("span", _hoisted_38, _toDisplayString(booking.value?.leadbooking.bookingdate), 1),
                            _createElementVNode("span", _hoisted_39, _toDisplayString(booking.value?.leadbooking.starttime), 1),
                            _createElementVNode("span", _hoisted_40, _toDisplayString(booking.value?.leadbooking.endtime), 1),
                            _createElementVNode("span", _hoisted_41, "(" + _toDisplayString(masterReportType.value) + ") ", 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_appointmenttime.value != 'Invalid date')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      _hoisted_43,
                      _createElementVNode("span", _hoisted_44, _toDisplayString(_appointmenttime.value), 1)
                    ]))
                  : _createCommentVNode("", true),
                (booking.value.inspector && booking.value.inspector.name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      _hoisted_46,
                      _createTextVNode(" " + _toDisplayString(booking.value.inspector.name), 1)
                    ]))
                  : _createCommentVNode("", true),
                (subbookingdatetimeflag.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prepandKeyJobData.value, (prepdata, $prepdata) => {
                        return (_openBlock(), _createElementBlock("div", { key: $prepdata }, [
                          (prepdata.inspector.name)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                _hoisted_49,
                                _createElementVNode("span", null, _toDisplayString(prepdata.inspector.name), 1),
                                _createElementVNode("span", _hoisted_50, " (" + _toDisplayString(prepdata.subtype) + ") ", 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (booking.value?.leadbooking)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                      (booking.value?.leadbooking?.inspector || booking.value.leadbooking?.inspector.name)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                            _hoisted_53,
                            _createElementVNode("span", null, _toDisplayString(booking.value.leadbooking?.inspector.name), 1),
                            _createElementVNode("span", _hoisted_54, " (" + _toDisplayString(masterReportType.value) + ") ", 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (booking.value.bookedbyname || booking.value.bookedbymobile || booking.value.bookedbyemail)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(booking.value.bookedby, (bookedby, $bbindex) => {
                        return (_openBlock(), _createElementBlock("div", { key: $bbindex }, [
                          _hoisted_56,
                          _createElementVNode("span", _hoisted_57, _toDisplayString(bookedby.bbname), 1),
                          _createElementVNode("span", _hoisted_58, _toDisplayString(bookedby.bbemail), 1),
                          _createElementVNode("span", _hoisted_59, _toDisplayString(bookedby.bbmobile), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (booking.value.tenants.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(booking.value.tenants, (tenant, $bbindex) => {
                        return (_openBlock(), _createElementBlock("div", { key: $bbindex }, [
                          (tenant.ttname)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_61, [
                                _hoisted_62,
                                _createTextVNode(_toDisplayString(tenant.ttname), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (tenant.ttemail)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_63, [
                                _hoisted_64,
                                _createTextVNode(" " + _toDisplayString(tenant.ttemail), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (tenant.ttmobile)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_65, [
                                _hoisted_66,
                                _createTextVNode(_toDisplayString(tenant.ttmobile), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (booking.value.internaljobtype != 'Check-In - back to back')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                      (booking.value.keypickup)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_68, [
                            _hoisted_69,
                            _createTextVNode(_toDisplayString(booking.value.keypickup), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (booking.value.keypickup === 'From Agency' && booking.value.keypickupbranchname)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_70, [
                            _hoisted_71,
                            _createTextVNode(" " + _toDisplayString(booking.value.keypickupbranchname), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (((booking.value.keypickup === 'From Agency' || booking.value.keypickup === 'Via Concierge' || booking.value.keypickup === 'Via Landlord') && booking.value.keypickupfromaddress.phone))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_72, [
                            _hoisted_73,
                            _createTextVNode(" " + _toDisplayString(booking.value.keypickupfromaddress.phone), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (booking.value.connectedbooking && booking.value.connectedbooking.internaljobtype != 'Check-In - back to back')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                      (booking.value.releasekeysto)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_75, [
                            _hoisted_76,
                            _createTextVNode(_toDisplayString(booking.value.releasekeysto), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (booking.value.releasekeystobranchname)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_77, [
                            _hoisted_78,
                            _createTextVNode(_toDisplayString(booking.value.releasekeystobranchname), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (primaryErrors.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                      _hoisted_80,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(primaryErrors.value, (errors, $primaryerror) => {
                        return (_openBlock(), _createElementBlock("div", { key: $primaryerror }, [
                          _createElementVNode("span", null, _toDisplayString(errors.message), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (secondaryErrors.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                      _hoisted_82,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(secondaryErrors.value, (errors, $secondaryerror) => {
                        return (_openBlock(), _createElementBlock("div", { key: $secondaryerror }, [
                          _createElementVNode("span", null, _toDisplayString(getPresetErrorMessage(errors)), 1)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_83, [
              (booking.value.checkoutWithoutDataentry)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: "fas fa-2x fa-skull-crossbones icon-botton-right",
                    style: {"color":"yellow"},
                    title: skulltitle.value
                  }, null, 8, _hoisted_84))
                : _createCommentVNode("", true),
              (booking.value.provisional)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 1,
                    class: "fa fa-3x fa-exclamation-circle icon-botton-right",
                    style: {"color":"yellow"},
                    title: `Provisional booking: ${booking.value.provisionalnotes}`
                  }, null, 8, _hoisted_85))
                : _createCommentVNode("", true),
              (!booking.value.issued && !booking.value.provisional && booking.value.tenantattending != 'unsure' && booking.value.confirmaccess)
                ? (_openBlock(), _createElementBlock("i", _hoisted_86))
                : _createCommentVNode("", true),
              (booking.value.locked)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 3,
                    class: "fas fa-lock icon-botton-right",
                    style: {"color":"yellow"},
                    title: booking.value.lockedby
                  }, null, 8, _hoisted_87))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 14, _hoisted_1))
}
}

})